import React from 'react';
import Checkbox, { CheckboxProps } from '@material-ui/core/Checkbox';

export type CheckboxFieldProps = CheckboxProps;

export const CheckboxField: React.FC<CheckboxFieldProps> = ({ color = 'primary', ...props }) => {
  return <Checkbox color={color} {...props} />;
};